import "./ChangeSecurityQuestionTemplate.html";
export var template: string = require('./ChangeSecurityQuestionTemplate.html');

import ko = require('knockout');
import SecurityQuestion from "Models/Security/SecurityQuestionModel";
import UserSecurityQuestions from "Models/Security/UserSecurityQuestionsModel";
import SecurityQuestionAnswerModel from "Models/Security/SecurityQuestionAnswerModel";
import SecurityService from "Services/SecurityService";
import ValidateableViewModel from "ValidateableViewModel";

class SecurityQuestionAnswerViewModel extends ValidateableViewModel {
    id: KnockoutObservableArray<number>;
    answer: KnockoutObservable<string>;
    isEditable: KnockoutObservable<boolean>;

    constructor(id: number, isEditable: boolean) {
        super();

        this.id = ko.observableArray<number>([id]).extend({
            min: {
                message: 'You must select a question',
                params: 1
            }
        });
        this.isEditable = ko.observable(isEditable);
        this.answer = ko.observable("").extend({
            required: {
                message: 'You must enter an answer',
                onlyIf: () => {
                    return this.isEditable();
                }
            }
        });
    }

    enableSecurityQuestion = () => {
        this.isEditable(true);
    }
}

class ChangeSecurityQuestionViewModel {
    availableQuestions: KnockoutObservableArray<SecurityQuestion>;
    securityQuestions: KnockoutObservableArray<SecurityQuestionAnswerViewModel>;

    securityService: SecurityService;

    showCancel: KnockoutObservable<boolean>;

    onSave: any;
    onCancel: any;

    constructor(params: any) {
        if (typeof params.onSave === 'function') {
            this.onSave = params.onSave;
        }

        if (typeof params.onCancel === 'function') {
            this.onCancel = params.onCancel;
        }

        this.securityService = new SecurityService();

        this.availableQuestions = ko.observableArray<SecurityQuestion>();
        this.securityQuestions = ko.observableArray<SecurityQuestionAnswerViewModel>();
        this.showCancel = ko.observable(true);

        if (typeof params.showCancel !== 'undefined' && params.showCancel !== null) {
            this.showCancel(params.showCancel);
        }

        this.updateQuestionsFromServer();
    }

    filteredQuestions = (questionNum: number) => {
        var usedIds = [];

        // Note the push looks funky but that is because we have to pull from an arrow of numbers since it is
        // hooked up to a dropdown which doesn't give single numbers because if you do a multi select dropdown
        // you could have any number of ids
        for (let i = 0; i < this.securityQuestions().length; i++) {
            if (i != questionNum)
                usedIds.push(this.securityQuestions()[i].id()[0]);
        }

        return this.availableQuestions().filter(question => {
            return usedIds.indexOf(question.id) == -1;
        });
    }

    updateQuestionsFromServer = () => {
        this.securityService.getUserSecurityQuestions().then((data: UserSecurityQuestions) => {
            this.availableQuestions.removeAll();
            for (var i in data.allSecurityQuestions) {
                this.availableQuestions.push(data.allSecurityQuestions[i]);
            }

            this.securityQuestions.removeAll();
            for (var i in data.securityQuestionAnswers) {
                this.securityQuestions.push(new SecurityQuestionAnswerViewModel(
                    data.securityQuestionAnswers[i].id,
                    !data.securityQuestionAnswers[i].answerStored));
            }
        });
    }

    cancelChanges = () => {
        this.updateQuestionsFromServer();
        this.onCancel();
    }

    saveQuestions = () => {
        if (this.isAllQuestionsValid()) {
            var questions = new UserSecurityQuestions();
            questions.securityQuestionAnswers = [];

            for (var i in this.securityQuestions()) {
                var question = new SecurityQuestionAnswerModel();

                question.id = this.securityQuestions()[i].id()[0];
                question.answer = this.securityQuestions()[i].answer();

                questions.securityQuestionAnswers.push(question);
            }

            this.securityService.saveUserSecurityQuestions(questions).then(data => {
                this.updateQuestionsFromServer();
                this.onSave();
            });
        }
    }

    private isAllQuestionsValid(): boolean {
        var isValid = true;

        for (var i in this.securityQuestions()) {
            if (!this.securityQuestions()[i].isValid()) {
                isValid = false;
            }
        }

        return isValid;
    }
}

export var viewModel = ChangeSecurityQuestionViewModel;